export default __webpack_public_path__ + "static/instagram-phone-6291b514149027ef326e91311d7c68ed.png";